import React from "react";
import { Card, CardBody, Badge, Table, Button } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";

const RecentCollectionsFeed = ({ transactions = [] }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const getPaymentModeBadge = (mode = "") => {
    const m = mode.toLowerCase();
    if (m.includes("cash")) return <Badge color="soft-success" className="text-success">{t("Cash")}</Badge>;
    if (m.includes("upi") || m.includes("gpay") || m.includes("phonepe")) return <Badge color="soft-primary" className="text-primary">{t("UPI / QR")}</Badge>;
    if (m.includes("card") || m.includes("debit") || m.includes("credit")) return <Badge color="soft-info" className="text-info">{t("Card")}</Badge>;
    if (m.includes("net") || m.includes("bank")) return <Badge color="soft-warning" className="text-warning">{t("NetBanking")}</Badge>;
    return <Badge color="soft-secondary" className="text-secondary">{mode || t("Cheque")}</Badge>;
  };

  return (
    <Card className="border-0 shadow-sm mb-4 h-100">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
          <div className="d-flex align-items-center">
            <div className="avatar-xs me-2">
              <span className="avatar-title rounded bg-soft-success text-success font-size-16">
                <i className="bx bx-receipt" />
              </span>
            </div>
            <div>
              <h5 className="card-title mb-0 font-size-15 fw-bold">
                {t("Recent Financial Collections & Receipts")}
              </h5>
              <div className="text-muted font-size-11">
                {t("Latest payments recorded across reception and accounts")}
              </div>
            </div>
          </div>

          <Link
            to="/accounts"
            className="btn btn-sm btn-outline-success font-size-12 px-2 py-1"
          >
            {t("Accounts Hub")} <i className="bx bx-chevron-right ms-1" />
          </Link>
        </div>

        {transactions.length === 0 ? (
          <div className="text-center py-4 text-muted bg-light rounded">
            <i className="bx bx-receipt font-size-24 text-secondary mb-1 d-block" />
            <div className="font-size-13 fw-medium">{t("No recent transactions")}</div>
            <div className="font-size-11">{t("Payments will stream here in real time.")}</div>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover className="align-middle table-nowrap mb-0 font-size-12">
              <thead className="table-light text-muted">
                <tr>
                  <th>{t("Receipt No")}</th>
                  <th>{t("Patient")}</th>
                  <th>{t("Mode")}</th>
                  <th>{t("Date & Time")}</th>
                  <th className="text-end">{t("Amount Collected")}</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx, idx) => {
                  const patientName = tx.patient
                    ? `${tx.patient.first_name || ""} ${tx.patient.last_name || ""}`.trim()
                    : t("Patient");

                  return (
                    <tr key={tx.id || idx}>
                      <td>
                        <span className="fw-semibold text-primary font-size-11">
                          #{tx.receipt_no || tx.billing_no || `REC-${tx.id}`}
                        </span>
                      </td>
                      <td>
                        <div className="fw-semibold text-dark font-size-13">
                          {tx.patient ? (
                            <Link to={`/patient/details/${tx.patient.id}?tab=billing`} className="text-dark">
                              {patientName}
                            </Link>
                          ) : (
                            patientName
                          )}
                        </div>
                        {tx.remark && (
                          <div className="text-muted font-size-11 text-truncate" style={{ maxWidth: "200px" }}>
                            {tx.remark}
                          </div>
                        )}
                      </td>
                      <td>{getPaymentModeBadge(tx.payment_mode)}</td>
                      <td className="text-muted font-size-11">
                        <i className="mdi mdi-clock-outline me-1" />
                        {moment(tx.created_at).format("DD MMM, hh:mm A")}
                      </td>
                      <td className="text-end fw-bold text-success font-size-13">
                        +₹{Number(tx.amount || 0).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default RecentCollectionsFeed;
